import React, { memo } from "react";
import formchoice from "data/form-choice.json";
import "./style.css";
import { Link } from "react-router-dom";

const FormChoice = ({ haveBackground = false }) => {
  return (
    <>
      <div
        className="w-full relative md:pt-[100px] md:pb-[168px]"
        id="id-form-choice"
      >
        {haveBackground && (
          <div
            className="w-full h-full absolute top-0 left-0 z-0 bg-primary-300 hidden md:block"
            style={{
              backgroundImage: 'url("/images/pattern-form-choice.png")',
              backgroundRepeat: "repeat",
            }}
          ></div>
        )}
        <div className="relative z-[1] px-24 md:px-0">
          <div className="pt-[20px] pb-[16px] px-16 md:pt-0 text-center">
            <h1 className="text-[48px] leading-[100%] text-neutral-100 font-taviraj block md:hidden">
              Ready to make an impact together?
            </h1>
            <h1 className="text-[48px] leading-[100%] text-neutral-100 font-taviraj hidden md:block">
              Ready to take the next step? <br />
              Contact us now!
            </h1>
            <p className="hidden md:block mt-[40px] text-[14px] md:text-16 leading-[17.5px] text-[#EBC797]">
              *If you have any questions, you can reach us at{" "}
              <a
                href="mailto:business@eternalpetite.com"
                className="inline-block leading-[23.88px] underline"
              >
                business@eternalpetite.com
              </a>
            </p>
          </div>
          <div className="flex flex-col md:flex-row md:justify-center gap-32 md:gap-[128px] mt-32 md:mt-[76px]">
            {formchoice?.map((item, index) => {
              return (
                <div
                  className="w-full relative md:min-h-[196px] md:w-[408px] form-choice-link-wrapper"
                  key={index}
                >
                  <span className="block md:hidden text-14 leading-[18px] mb-8 text-primary-800 text-center">
                    {item.subtitle}
                  </span>
                  <Link to={item.link} className="form-choice-link block">
                    <div className="relative">
                      <div
                        className={`relative top-0 left-0 w-full py-16 md:py-24 px-24 md:px-32 z-[1] text-center md:text-left ${
                          index === 0 ? "bg-primary-500" : "bg-tertiary-600"
                        }`}
                      >
                        <div
                          className="w-full h-full absolute top-0 left-0 z-0"
                          style={{
                            background:
                              index === 0
                                ? 'url("/images/bg-about-pattern.png"), #391A06'
                                : 'url("/images/bg-about-pattern.png"), #A96074',
                            backgroundBlendMode: "soft-light, normal",
                          }}
                        ></div>
                        <h5 className="text-24 leading-[36px] md:leading-[40.94px] text-neutral-100 font-taviraj relative">
                          {item.title}
                        </h5>
                        <p className="text-16 md:text-20 leading-[27px] text-primary-900 font-taviraj m-0 overflow-hidden block form-choice-link-desc relative">
                          <span className="block">{item.description}</span>
                        </p>
                      </div>
                      <img
                        src={`/images/thumb/${item.image.desktop}`}
                        alt={item.image.mobile}
                        className="w-full object-cover object-center hidden md:block"
                        loading="lazy"
                      />
                    </div>
                    {/* <div className="relative block md:hidden">
                      <img
                        src={`/images/thumb/${item.image.mobile}`}
                        alt={item.image.mobile}
                        className="w-full h-[221px] object-cover object-center block"
                        loading="lazy"
                      />
                      <div className="w-full absolute top-0 left-0 h-full p-16 block">
                        <div className="w-full h-full font-taviraj flex items-center ">
                          <div className="">
                            <h5 className="text-24 leading-[40.94px] text-neutral-50">
                              {item.title}
                            </h5>
                            <span className="text-16 leading-[27px] text-primary-900">
                              {item.description}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </Link>
                </div>
              );
            })}
          </div>
          <div className="block md:hidden py-[40px]">
            <p className="block text-[14px] md:text-16 leading-[17.5px] text-[#EBC797] text-center">
              *If you have any questions, you can reach us at{" "}
              <a
                href="mailto:business@eternalpetite.com"
                className="inline-block leading-[23.88px] underline"
              >
                business@eternalpetite.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(FormChoice);
